<template>
  <template v-if="range">
    <v-date-picker
      color="blue"
      locale="it-IT"
      v-model.range="date"
      @update:modelValue="emitDate"
      :popover="false"
    >
      <template #default="{ togglePopover }">
        <div class="field has-addons m-0">
          <p class="control">
            <button class="button" @click="() => togglePopover()">
              <span class="icon is-small">
                <font-awesome-icon icon="calendar" class="m-0" />
              </span>
            </button>
          </p>
          <p class="control is-expanded">
            <input :value="modelValue?.start?.toDisplay()" class="input" :placeholder="placeholder" @click="selectAll" @focusout="e => focusout(e, 'start')" />
          </p>
          <p class="control is-expanded">
            <input :value="modelValue?.end?.toDisplay()" class="input" :placeholder="placeholder" @click="selectAll" @focusout="e => focusout(e, 'end')" />
          </p>
        </div>
      </template>
    </v-date-picker>
  </template>
  <template v-else>
    <v-date-picker
      color="blue"
      locale="it-IT"
      v-model="date"
      @update:modelValue="emitDate"
    >
      <template #default="{ inputValue, inputEvents }">
        <input :value="inputValue" class="input" :placeholder="placeholder" v-on="inputEvents" />
      </template>
    </v-date-picker>
  </template>
</template>

<script>
  export default {
    props: {
      modelValue: {
        type: Object,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      range: {
        type: Boolean,
        default: false
      },
      showIcon: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    emits: ['update:modelValue', 'update'],

    data() {
      return {
        date: this.modelValue
      }
    },

    methods: {
      emitDate() {
        if (this.range) {
          if (this.date && this.date.start && this.date.end) {
            this.$emit('update:modelValue', this.date)
            this.$emit('update', this.date)
          }
        } else {
          this.$emit('update:modelValue', this.date)
          this.$emit('update', this.date)
        }
      },

      selectAll(e) {
        e.target.select()
      },

      focusout(event, type = 'start') {
        const value = event.target.value

        const parts = value.split('/')

        if (parts.length === 3) {
          const newDate = new Date(parts[2], parts[1] - 1, parts[0])

          this.date[type] = newDate

          this.$emit('update:modelValue', this.date)
          this.$emit('update', this.date)
        }
      }
    },

    watch: {
      modelValue(newValue) {
        if (newValue) {
          if (newValue.start && newValue.end) {
            this.date = newValue
          } else {
            this.date = new Date(newValue)
          }
        }
      }
    }
  }
</script>

<style lang="scss">
.vc-header button {
  background-color: transparent !important;
  background-image: none;
  font-size: 100%;
}
</style>